import { v4 as uuidv4 } from 'uuid';
import packageInfo from '../../../../../package.json';

async function getRecommendations() {
    const version = packageInfo.version;
    try {
        const response = await fetch(`/defaultRecommendations.json?v=${version}`);
        if (!response.ok) throw new Error('Failed to fetch recommendations');
        const data = await response.json();
        this.recommendations = data.data;
        this.observed.recommendations = uuidv4();
    } catch (error) {
        console.error('getRecommendations error:', error);
    }
}

export default getRecommendations;
